const form = {
  requiredEmail: "Email address is required.",
  requiredPassword: "Password is required.",
  requiredUserType: "Please select an account type",
  dateMustBeComplete: "The date must be complete.",
  requiredExample: "Example is required.",
  requiredFirstname: "First name is required.",
  requiredLastname: "Last name is required.",
  requiredMessage: "The message cannot be empty.",
  requiredCity: "City is required.",
  validEmail: "Please enter a valid email address.",
  tooLong: "this field is limited to {value} characters.",
  subject: "Subject",
  description: "Description",
  category: "Category",
  acceptDataProcessing:
    "I agree that my data may be shared with the development team.",
  invalidForm: "Invalid form.",
  requiredFields: "Fields marked with * are required.",
  allFieldsRequired: "All fields are required.",
};

export default form;
